import { StyleSheet } from 'react-native';

import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    headingContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: Theme.primaryMargin,
        paddingVertical: 15
    },
    heading: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 20,
        marginStart: Device.isPhone ? '17%' : '20%',
        marginVertical: '3%'
    },
    switchContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    switchText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 20,
        marginLeft: 10
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            position: 'absolute',
            right: 0,
            height: '100%',
            width: '50%',
            borderLeftWidth: 1,
            borderLeftColor: Theme.secondaryButtonBorderColor,
            backgroundColor: 'rgba(0, 0, 0, 0.9)'
        },
        headingContainer: {
            ...baseStyles.headingContainer,
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingHorizontal: 20
        },
        heading: {
            ...baseStyles.heading,
            fontSize: 20,
            marginStart: 0,
            marginVertical: '3%'
        }
    };
}

export default StyleSheet.create(baseStyles);
